export const HEADER_HEIGHT = 200;
export const MAX_HEIGHT = 520;
export const CONTENT_WIDTH = '375px';
